
import ButtonIconSelect from "components/ButtonIconSelect";

export default class ButtonComponentSelect extends ButtonIconSelect {

    insertPopupItem(it, i) {
        return (
            <div
                key={i}
                className={"popupItem flex centerV between component" + this.getPopupItemStyle(it, i)}
            >
                {it.content(this.onClose.bind(this), this.props.info)}
            </div>
        );
    }

    onClose() {
        this.setOpenedState(false);
    }

    toggleOpenedState() {
        if (this.props.eventToggle)
            this.props.eventToggle();
        super.toggleOpenedState();
    }

    renderSelector() {
        const { component } = this.props;

        return (
            <div ref={el => this.selector = el} style={{ width: "40px", maxWidth: "40px" }}>
                <div onClick={this.toggleOpenedState.bind(this)}>
                    {component}
                </div>
            </div>
        );
    }
}
